import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const sendMessage = gql`
  mutation SendThreadMessageMutation($input: CreateThreadMessage!) {
    createdMessage: createThreadMessage(input: $input) {
      ...ThreadMessage
    }
  }

  ${Fragments.thread.message}
`;

export const editMessage = gql`
  mutation EditThreadMessageMutation($input: UpdateThreadMessage!) {
    editedMessage: updateThreadMessage(input: $input) {
      ...ThreadMessage
    }
  }

  ${Fragments.thread.message}
`;

export const deleteMessage = gql`
  mutation DeleteThreadMessageMutation($id: Int!) {
    deletedMessage: deleteThreadMessage(id: $id)
  }
`;

export const markMessagesAsRead = gql`
  mutation MarkThreadMessagesAsReadMutation($threadId: UUID!) {
    createClientEvent(input: { threadId: $threadId, event: MESSAGES_VIEWED }) {
      id
    }
  }
`;
